import React from 'react';

const FormulaLink = ({ onClick, isSplitSame }) =>
  isSplitSame && (
    <div style={{ display: 'flex', alignItems: 'left', marginRight: 10 }}>
      <a
        className="btn btn-primary"
        onClick={(e) => {
          e.preventDefault();
          onClick();
        }}
        onKeyDown={() => {}}
      >
        Formula
      </a>
    </div>
  );

export default FormulaLink;
